export default __webpack_public_path__ + "static/media/9131585e4307c3a73350f2777cbfb329.svg";